// extracted by mini-css-extract-plugin
export default {"wrapper":"MusicPlayer_wrapper__XDMMB","slider":"MusicPlayer_slider__7xgL-","volume-text":"MusicPlayer_volume-text__hfmA7"};